// extracted by mini-css-extract-plugin
module.exports = {"map":"style_map__wuwsg","portfolio":"style_portfolio__2eWZf","bigPicture":"style_bigPicture__G8sUe","user":"style_user__3T_EC","travelDescription":"style_travelDescription__1B9ev"};